<template>
  <b-card no-body tag="div" class="mb-2">
    <div>
      <div
        class="fixed-ratio bg-light"
        :style="{
          'padding-bottom': `${imgRatio}%`,
        }"
      >
        <img src="../assets/ball.gif" class="loader" />
        <img v-lazy="ImgSrc" class="fixed-ratio-content" />
      </div>

      <b-card-body>
        <div class="row">
          <div class="col">
            <h5 class="pt-3 mb-0">{{ CardTitle }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>{{ CardTagline }}</b>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <p class="card-text">{{ CardText }}</p>
          </div>
        </div>
      </b-card-body>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'TestimonialCard',
  computed: {
    imgRatio() {
      return Math.ceil((this.$props.ImgHeight / this.$props.ImgWidth) * 100);
    },
  },
  props: [
    'Id',
    'CardTitle',
    'CardText',
    'CardTagline',
    'ImgSrc',
    'ImgAlt',
    'ImgHeight',
    'ImgWidth',
  ],
};
</script>

<style scoped>
.loader {
  width: 50px;
  height: 50px;

  position: absolute;
  top: 50%;
  left: 50%;

  margin: -25px 0 0 -25px;
}
</style>



// WEBPACK FOOTER //
// src/components/TestimonialCard.vue